import DestinationPage from '@/components/DestinationPage';

const Vendee = () => {
  return (
    <DestinationPage
      title="Location de vélos en Vendée"
      subtitle="Explorez la Vendée à vélo : côte sauvage, forêts et patrimoine historique"
      description="La Vendée offre une diversité de paysages exceptionnelle pour les amateurs de vélo. Entre la côte atlantique sauvage, les forêts de pins, les marais et le bocage vendéen, chaque sortie est une nouvelle découverte. Profitez des nombreuses pistes cyclables aménagées pour explorer cette région authentique."
      highlights={[
        "Pistes cyclables le long de la côte atlantique",
        "Forêt de pins et sentiers ombragés",
        "Marais poitevin accessible à vélo",
        "Villages de caractère et patrimoine",
        "Plages familiales et spots de surf",
        "Itinéraires nature et culturels"
      ]}
    />
  );
};

export default Vendee;